import { searchPOApi } from "services/poService";
import { SEARCH_PO_FAILURE, SEARCH_PO_REQUEST, SEARCH_PO_RESET, SEARCH_PO_SUCCESS } from "./action-type";

export const searchPO = (payload) => {
    return (dispatch) => {
        dispatch(searchPORequest());
        searchPOApi(payload)
            .then((response) => {
                if (response.status === 200)
                    dispatch(searchPOSuccess(response));
                else
                    dispatch(searchPOFailure(response));
            })
            .catch(error => {
                dispatch(searchPOFailure(error));
             })
    }
}

export const searchPORequest = () => {
    return {
        type: SEARCH_PO_REQUEST
    }
};

export const searchPOSuccess = (response) => {
    return {
        type: SEARCH_PO_SUCCESS,
        searchPOResponse: response
    }
};

export const searchPOFailure = (error) => {
    return {
        type: SEARCH_PO_FAILURE,
        searchPOResponse: error
    }
};

export const searchPOReset = () => {
    return {
        type: SEARCH_PO_RESET
    }
};